<template>
  <div :class="$mediaScreen.layoutFooter('-container', $vssWidth)">
	<div :class="$mediaScreen.layoutFooter('-layout', $vssWidth)">
    <div class="grid" style="max-width: 1024px;margin-left: auto;margin-right: auto;padding: 2em 0 0 0;">
      <div class="col-12 md:col-6 privacy">
        <p class="font-bold ml-2">{{$t("footer.useful-links")}}</p>
        <p class="font-light ml-2"><a href="https://www.esmo.org/newsroom/media-policies" target="_blank">{{$t("footer.esmo-media-policies")}}</a></p>
        <p class="font-bold ml-2" style="margin-top: 1em">{{$t("footer.privacy")}}</p>
        <p class="font-light ml-2"><a href="https://www.esmo.org/terms-of-use" target="_blank">{{$t("footer.terms-of-use")}}</a></p>
        <p class="font-light ml-2"><a href="https://www.esmo.org/terms-of-use/privacy-policy" target="_blank">{{$t("footer.privacy-policy")}}</a></p>
        <p class="font-light ml-2"><span @click="showCookieDialog()" style="text-decoration: underline; cursor: pointer">{{$t("footer.cookies-settings")}}</span></p>

      </div>
      <div class="col-12 md:col-6 useful-links">
        <p class="font-bold ml-2">{{$t("footer.contactUs")}}</p>
        <div class="font-light ml-2" style="text-align: justify-all">{{$t("footer.text1")}}
          <a href="mailto:press@esmo.org">press@esmo.org</a></div>
      </div>
      <div class="col-12 sub-footer">
        <p>{{$t("footer.text2")}}</p>
        <p>Via Ginevra 4, 6900 Lugano - CH</p>
        <p>© Copyright 2022 European Society for Medical Oncology All rights reserved worldwide.</p>
      </div>
    </div>
    <Dialog v-model:visible="cookieDialogIsVisible" :closable="false" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '100%'}" position="bottom" :modal="true">
      <div class="grid" style="padding:1em">
        <div class="col-12 lg:col-6">
          {{$t("footer.text3")}}<br>
          {{$t("footer.text4")}}
          <a href="https://www.esmo.org/terms-of-use/privacy-policy" target="_blank">{{$t("footer.privacy-policy")}}</a>.
        </div>
        <div class="col-12 lg:col-6" style="text-align: right;">
          <Button @click="rejectAllCookies()" class="cookie-buttons reject-all">{{$t("cookies.reject-all")}}</Button>
          <Button @click="acceptAllCookies()" class="cookie-buttons accept-all">{{$t("cookies.accept-all")}}</Button>
          <div @click="toggleCustomiseCookies()" style="text-decoration: underline; cursor: pointer;margin-top: 1em">{{$t("cookies.customise")}}</div>
        </div>
        <div v-if="customiseCookiesIsVisible" class="col-12 grid" style="margin-top: 1em;margin-bottom: 1em;">
          <div class="col-12 md:col-4">
            <InputSwitch v-model="selectedBaseCookies" />
            <p><b>{{$t("cookies.baseCookiesTitle")}}</b></p>
            <p>{{$t("cookies.baseCookiesBody")}}</p>
          </div>
          <div class="col-12 md:col-4">
            <InputSwitch v-model="selectedAnalyticsCookies" />
            <p><b>{{$t("cookies.analyticsCookiesTitle")}}</b></p>
            <p>{{$t("cookies.analyticsCookiesBody")}}</p>
          </div>
          <div class="col-12 md:col-4">
            <InputSwitch v-model="selectedMarketingCookies" />
            <p><b>{{$t("cookies.marketingCookiesTitle")}}</b></p>
            <p>{{$t("cookies.marketingCookiesBody")}}</p>
          </div>
          <div class="col-12">
            <Button @click="saveCookieSettings()" class="cookie-buttons save" style="float: right">{{$t("cookies.save")}}</Button>
          </div>
        </div>
      </div>
    </Dialog>
	</div>
  </div>
</template>

<script>
	import {useApplicationStore} from "@/store/applicationStore";
  import { VueScreenSizeMixin } from 'vue-screen-size';

  export default {
    mixins: [VueScreenSizeMixin],
		name: "AppFooter",
    beforeCreate() {
      this.applicationStore = useApplicationStore()
    },
    data() {
      return {
        selectedBaseCookies: true,
        selectedAnalyticsCookies: false,
        selectedMarketingCookies: false,
        cookieDialogIsVisible: false,
        customiseCookiesIsVisible: false
      }
    },
		methods: {
      toggleCustomiseCookies(){
        this.customiseCookiesIsVisible = !this.customiseCookiesIsVisible
      },
      saveCookieSettings(){
        this.applicationStore.setBaseCookies(this.selectedBaseCookies)
        this.applicationStore.setAnalyticsCookies(this.selectedAnalyticsCookies)
        this.applicationStore.setMarketingCookies(this.selectedMarketingCookies)
        this.customiseCookiesIsVisible =false;
        this.hideCookieDialog()
      },
      acceptAllCookies() {
        this.selectedBaseCookies = true
        this.selectedAnalyticsCookies = true
        this.selectedMarketingCookies = true
        this.saveCookieSettings()
      },
      rejectAllCookies() {
        this.selectedBaseCookies = false
        this.selectedAnalyticsCookies = false
        this.selectedMarketingCookies = false
        this.saveCookieSettings()
      },
      showCookieDialog() {
        this.cookieDialogIsVisible = true;
			},
      hideCookieDialog() {
        this.cookieDialogIsVisible = false;
      },
      activateAnalytics(){
        if(this.analyticsCookies === true){
          this.$gtm.enable(true)
        } else {
          this.$gtm.enable(false)
        }
      }
		},
		computed: {
			darkTheme() { return this.$appState.darkTheme },
      baseCookies() { return this.applicationStore.baseCookies },
      analyticsCookies() { return this.applicationStore.analyticsCookies },
      marketingCookies() { return this.applicationStore.marketingCookies }
		},
    mounted() {
      this.selectedAnalyticsCookies = this.analyticsCookies
      this.selectedMarketingCookies = this.marketingCookies
      if(!this.baseCookies === true){
        this.showCookieDialog()
      }
      if(this.analyticsCookies === true){
        this.activateAnalytics()
      }
    },
    watch: {
      analyticsCookies() {
        this.activateAnalytics()
      }
    }
  }
</script>

<style scoped lang="scss">
@import "public/theme/theme-esmo";

.cookie-buttons{
  min-width: 10em;
  font-family: "HelveticaLTW05-BlackCond", Arial, Helvetica, sans-serif;
  padding: .8em;
  border: 2px solid $primaryColor;
  margin: .2em;

  &.reject-all,&.save{
    color: $primaryColor;
    background: transparent;
  }
}

.layout-footer{
  overflow: hidden;
  p {
    margin: 0;
  }
}
.privacy,.useful-links,.contact-us{

  a {
    color: white!important;
    text-decoration: underline;
  }
}
.sub-footer{
  margin-top: 2em!important;
  padding: 2em!important;
  border-top: 1px solid white;
}
.font-bold{
  margin-bottom: .6em!important;
}
</style>